import axios from 'axios'

export async function refreshWebsiteTitle() {
  try {
    const { data } = await axios.get('/api/website!titles.action', { timeout: 8000 })
    if (typeof data.frontendTitle === 'string' && data.frontendTitle.trim()) document.title = data.frontendTitle
  } catch (_) { /* Keep the existing title when configuration is unavailable. */ }
}
